﻿import { response_details } from "./response_details";

export class payment_response {
    public paymentStatus: string | null = null;
    public paymentSuccessful: boolean = false;
    public transactionId: string | null = null;
    public transactionRef: string | null = null;
    public paymentDetails: response_details = new response_details();
    public event: string | null = null;
    public customSuccessPage : boolean = false;
}